import React from 'react';
import { Wrapper } from './styles';

const Spinner = ({ color = '#606060' }: { color?: string }) => (
  <Wrapper
    width="24"
    height="24"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
  </Wrapper>
);

export default Spinner;
